export enum SellerRoleEnum {
  BLOCKED = 'Bloqueado',
  SELLER = 'Representante',
  SUPERVISOR = 'Supervisor',
}

export type SellerRoleEnumKeys = keyof typeof SellerRoleEnum
